import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button2_click_1(event) {
	let value  = $w('#input1').value
	if (value === 'Beinleumi' || value === 'beinleumi' || value === 'BEINLEUMI'){
		wixWindow.openLightbox("photo2");
	}
	else{
			wixWindow.openLightbox("no");
	}
}